import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import state from "./state";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

let nStore = new Vuex.Store({
    getters,
    state,
    actions,
    mutations
});
const originRegister = nStore.registerModule

nStore.registerModule = registerModule

function registerModule(name, moduleState) {
    originRegister.call(nStore, name, state[name] ? {
        ...moduleState,
        state: state[name]
    } : moduleState)
}
export default nStore